import { cn } from '@/shared/lib/utils'

interface CountBadgeProps {
  count: number
  className?: string
}

/**
 * Overlay count marker for the corner of an icon or avatar — the app-icon
 * style notification badge. Renders nothing at zero. Decorative only: the
 * host control must carry the count in its accessible name.
 */
export function CountBadge({ count, className }: CountBadgeProps) {
  if (count <= 0) return null
  return (
    <span
      aria-hidden="true"
      className={cn(
        'absolute -top-0.5 -right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-bold text-destructive-foreground',
        className
      )}
    >
      {count > 9 ? '9+' : count}
    </span>
  )
}
